import script from "./sbx-label-pastoral-points.ce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sbx-label-pastoral-points.ce.vue?vue&type=script&setup=true&lang=ts"
export * from "./sbx-label-pastoral-points.ce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sbx-label-pastoral-points.ce.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__